import { Accordion, AccordionDetails, AccordionSummary, Divider, Grid, Typography, useMediaQuery } from '@mui/material'
import React, { useContext } from 'react'
import styles from "../../../../../assets/styles/componentStyles/ticketStyles/ticket.module.scss";
import chatStyles from "../../../../../assets/styles/componentStyles/chatbotStyles/chats.module.scss";
import globalStyles from "../../../../../assets/styles/global.module.scss";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useShallow } from 'zustand/react/shallow';
import { threadTickets } from '../../../../../models/axiosModel';
import EditIcon from '@mui/icons-material/Edit';
import { UserContext, UserContextPayload } from '../../../../../context/userContext';
import { formatDateAccordingToTimezoneUsingMoment } from '../../../../../utils/constants';
import { useTicketStore } from '../../../../../store/ticketStore';
import IconsColor from '../../../../../components/utility/iconsColor';
import { primaryColor } from '../../../../../utils/colors';
import { TICKET_FIELDS } from '../../../constants';
import { shouldShowCreateTicketOption } from '../../../utils';
import { useRuleBasedInboxStore } from '../../../../../store/ruleBasedInboxStore';
import clsx from "clsx";

const TicketHistory = () => {
    
    const { currentActiveChatbotThread, setFlagOpenThreadInfoBlock, flagOpenThreadInfoBlock } = useRuleBasedInboxStore(useShallow((state) => ({
        currentActiveChatbotThread: state.currentActiveChatbotThread,
        setFlagOpenThreadInfoBlock: state.setFlagOpenThreadInfoBlock,
        flagOpenThreadInfoBlock: state.flagOpenThreadInfoBlock,
    })))

    const { setSelectedTicket, setFlagCreateTicketPopup } = useTicketStore(
        useShallow((state) => ({
            setSelectedTicket: state.setSelectedTicket,
            setFlagCreateTicketPopup: state.setFlagCreateTicketPopup
        }))
    )

    const laptopScreen = useMediaQuery('(max-width : 1600px) and (min-width : 1000px)')
    const { organizationDetails, userDetail, apiRoutesPermissionAssignment } = useContext(UserContext) as UserContextPayload

    const getTicketStatus = (ticket: threadTickets) => {
        return ticket?.status_assignments?.find((status) => !status?.flag_substatus) || null;
    }

    const getTicketHeading = (ticket: threadTickets) => {
        const ticketHeadingField = ticket?.field_data?.find((field) => field?.thread_ticket_field_name === TICKET_FIELDS['HEADING']);
        let ticketHeading = '';
        if(ticketHeadingField){
            ticketHeading = ticketHeadingField?.field_value;
        }

        return ticketHeading;
    }

    const getTicketCreatedBy = (ticket: threadTickets) => {
        const createdByUser = organizationDetails?.[0]?.organization_user_data?.find((user) => user?.user_assignment_id === ticket?.created_by_user_assignment_id);
        let cratedByUserName = 'Unknown';
        if(createdByUser){
            cratedByUserName = `${createdByUser?.private_user_first_name || ""} ${createdByUser?.private_user_last_name || ""}`;
        }

        return cratedByUserName;
    }

    const getTicketAssignment = (ticket: threadTickets) => {
        let ticketAssignmentTitle = 'Unassigned';
        const ticketAssignment = ticket?.agent_assignments || [];
        const isTicketAssigned = ticketAssignment?.length > 0;
        if(isTicketAssigned){
            if(ticketAssignment?.length === 1){
                ticketAssignmentTitle = ticketAssignment[0]?.agent_name;
            } else {
                ticketAssignmentTitle = `${ticketAssignment[0]?.agent_name} (+${ticketAssignment?.length - 1} more)`;
            }
        }
        return ticketAssignmentTitle;
    }
    
    const onClickOfEditTicket = (ticket: threadTickets) => {
        if(laptopScreen){
            setFlagOpenThreadInfoBlock(!flagOpenThreadInfoBlock);
        }
        setSelectedTicket(ticket); 
        setFlagCreateTicketPopup(true);
    }

    const onClickOfCreateTicket = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
        e.stopPropagation();
        setFlagCreateTicketPopup(true);
        setSelectedTicket(null);
    }
    
    return (
        <>
            <Grid item mt={2} ml={0.2} mr={0.2}>
                <Accordion className={styles.ticketHistoryAccordion} defaultExpanded>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                        className={styles.ticketHistoryAccordionSummary}
                    >
                        <Grid item xs={12} className={globalStyles.fullwidth}>
                            <Grid container justifyContent={"space-between"} alignItems={'center'}>
                                <Grid item>
                                    <Typography className={`${styles.ticketHistoryTitle}`}>
                                        {`Ticket History (${currentActiveChatbotThread ? currentActiveChatbotThread?.thread_ticket_data?.length : 0})`}
                                    </Typography>
                                </Grid>
                                {shouldShowCreateTicketOption(apiRoutesPermissionAssignment, userDetail) &&
                                    <Grid item>
                                        <span className={clsx(globalStyles.primaryColor, globalStyles.clickable, chatStyles.addTagStyles)} onClick={(e) => onClickOfCreateTicket(e)}>
                                            <IconsColor iconName='plus' width="15" height="15" fillColor={primaryColor} />
                                            Create
                                        </span>
                                    </Grid>
                                }
                            </Grid>
                        </Grid>
                    </AccordionSummary>
                    <AccordionDetails className={styles.ticketHistoryAccordionDetail}>
                        <Grid item>
                            <Grid container className={globalStyles.displayFlex} gap={1}>
                                {currentActiveChatbotThread && 
                                    currentActiveChatbotThread?.thread_ticket_data?.length > 0 ?
                                    currentActiveChatbotThread?.thread_ticket_data?.map((ticket) => {
                                        return (
                                            <Grid item xs={12}>
                                                <Grid container className={clsx(styles.ticketBlockContainer, globalStyles.displayFlex)} gap={1}>
                                                    <Grid item xs={12}>
                                                        <Grid container justifyContent={"space-between"} className={globalStyles.displayFlex}>
                                                            <Grid item className={styles.ticketRefNoGrid}>
                                                                <Typography className={styles.ticketRefNo}>
                                                                    {ticket?.ticket_reference_number}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item>
                                                                <Grid container className={globalStyles.displayFlex} gap={"6px"}>
                                                                    <Grid item className={styles.ticketStatus} style={{ backgroundColor: `${getTicketStatus(ticket)?.ticket_status_color ?? ''}`}}>
                                                                        {getTicketStatus(ticket)?.ticket_status_name ?? ''}
                                                                    </Grid>
                                                                    <Grid item title='Edit Ticket'>
                                                                        <EditIcon className={styles.editTicketIcon} onClick={() => onClickOfEditTicket(ticket)} />
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid item xs={12}>
                                                        <Typography className={clsx(globalStyles.secondaryFontSize, globalStyles.primaryFontWeight)}>
                                                            {getTicketHeading(ticket)}
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item xs={12}>
                                                        <Grid container gap={'4px'} className={globalStyles.displayFlex}>
                                                            {ticket?.status_assignments?.filter((status) => status?.flag_substatus)?.map((status) => {
                                                                return (
                                                                    <Grid item className={styles.subStatusChip} sx={{ background: `${status?.ticket_status_color}` }}>
                                                                        {status?.ticket_status_name}
                                                                    </Grid>
                                                                );
                                                            })}
                                                        </Grid>
                                                    </Grid>

                                                    <Grid item xs={12}>
                                                        <Divider />
                                                    </Grid>

                                                    <Grid item xs={12}>
                                                        <Grid container flexWrap={'nowrap'}>
                                                            <Grid item xs={6}>
                                                                <Grid container direction={'column'} gap={'2px'}>
                                                                    <Grid item>
                                                                        <Typography className={styles.createByTitle}>
                                                                            CREATED BY
                                                                        </Typography>
                                                                    </Grid>
                                                                    <Grid item>
                                                                        <Typography className={styles.createByTicket}>
                                                                            {getTicketCreatedBy(ticket)}
                                                                        </Typography>
                                                                    </Grid>
                                                                    <Grid item>
                                                                        <Typography className={styles.createByTitle}>
                                                                            {formatDateAccordingToTimezoneUsingMoment(ticket?.created_timestamp, userDetail.timezone_hour)}
                                                                        </Typography>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                <Grid container direction={'column'} gap={'2px'}>
                                                                    <Grid item>
                                                                        <Typography className={styles.createByTitle}>
                                                                            ASSIGNED TO
                                                                        </Typography>
                                                                    </Grid>
                                                                    <Grid item>
                                                                        <Typography className={styles.createByTicket}>
                                                                            {getTicketAssignment(ticket)}
                                                                        </Typography>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>

                                                </Grid>
                                            </Grid>
                                        );
                                    })
                                    : 
                                    <Grid item className={chatStyles.messageEntryValue}>
                                        No tickets created yet.
                                    </Grid>                     
                                }
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                </Accordion>
            </Grid>
        </>
    )
}

export default TicketHistory
